import HoneycombThemeProvider from './HoneycombThemeProvider';

export default HoneycombThemeProvider;
